module.exports = __webpack_public_path__ + "assets/img/announcement1.2.1e5049a2.png";